module.exports = __webpack_public_path__ + "static/media/yCRV-logo.29f067cf.jpg";